<template>
  <div class="row center-xs">
    <div class="search-bar col-xs-12">
      <div class="row right-xs">
        <div class="select-group col-xs-12 col-sm-5 col-med-4">
          <select
            name="Boolean Options"
            :id="idx"
            v-if="idx != 0"
            v-model="inputGroup.bool"
            @change="updateInput"
            aria-label="Boolean Options"
          >
            <option v-for="b in opts.bool" :value="b">{{ b }}</option>
          </select>
          <select
            name="Field Options"
            v-model="inputGroup.field"
            @change="updateInput"
            aria-label="Field Options"
          >
            <option v-for="f in opts.fields" :value="f.value">{{ f.label }}</option>
          </select>
        </div>
        <div class="col-xs-offset-1 col-sm-offset-0 col-xs-10 col-sm">
          <label :for="getIndex" class="sr-only">Search</label>
          <input
            v-model.trim="inputGroup.q"
            type="text"
            class=""
            placeholder="Enter keywords"
            @keyup.enter="triggerSearch"
            :id="getIndex"
          />
        </div>
        <div class="button-group col-xs-12 col-sm-2">
          <button class="btn btn-light" @click.prevent="addSearchBar">+</button>
          <button class="btn btn-light" v-if="idx != 0" @click.prevent="removeSearchBar">
            -
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, ref, reactive, toRaw, getCurrentInstance } from 'vue';

  const internalInstance = getCurrentInstance();
  const global = internalInstance.appContext.config.globalProperties;

  const props = defineProps({
    inputGroup: Object,
    idx: Number,
    opts: Object
  });

  // const group = reactive(props.inputGroup)
  // const idx = ref(props.idx)

  const emit = defineEmits(['updateInput', 'addSearchBar', 'removeSearchBar']);

  const getIndex = computed(() => props.idx);

  function updateInput() {
    emit('updateInput', { idx: props.idx, inputGroup: toRaw(props.inputGroup) });
  }

  function addSearchBar() {
    emit('addSearchBar');
  }

  function removeSearchBar() {
    emit('removeSearchBar', props.idx);
  }

  function triggerSearch() {
    emit('updateInput', { idx: props.idx.value, inputGroup: toRaw(props.inputGroup) });
    global.$eventBus.emit('new-search')
  }
  
  
</script>